import { Utils } from '@pacem/pacem-core';
const DefaultOmniLightReferences = {
    normal: 'normal', position: 'vertex', ray: 'ray', inputColor: 'white', specularColor: 'empty', shininess: '0'
};
export function omniLight(references, group, binding) {
    const key = Utils.uniqueCode();
    const lightReference = `omni_${key}`;
    const ref = Utils.extend({}, DefaultOmniLightReferences, references);
    const inputColor = ref.inputColor, outputColor = ref.outputColor, normal = ref.normal, ray = ref.ray, vertex = ref.position, shininess = ref.shininess, specularColor = ref.specularColor;
    if (Utils.isNullOrEmpty(inputColor)) {
        throw new Error('Must provide input vertex color parameter name.');
    }
    return {
        // type definitions
        definitions: [`struct OmniLight {
    color: vec4f,
    position: vec3f,
    intensity: f32
}`, `fn computeOmni(position: vec3f, normal: vec3f, ray: vec3f, color: vec4f, specularColor: vec4f, shininess: f32, light: OmniLight) -> vec4f {

    // color
    let n = normalize(normal);
    let d = normalize(position - light.position);
    let factor = light.intensity * .5 * (1.0 + dot(n, -d));

    // specular
    let r = normalize(ray);
    let halfVector = normalize(d + r);
    let specular = specularColor.rgb * shininess * dot(n, -halfVector);

    let output = color.rgb * light.color.rgb * factor + specular;
    return vec4f(output, color.a);
}`],
        // bindings
        bindings: [`@group(${group}) @binding(${binding}) var<uniform> ${lightReference}: OmniLight;`],
        // modifiers
        modifiers: outputColor ? [`${outputColor} += computeOmni(${vertex}, ${normal}, ${ray}, ${inputColor}, ${specularColor}, ${shininess}, ${lightReference});`] : [`computeOmni(${vertex}, ${normal}, ${ray}, ${inputColor}, ${specularColor}, ${shininess}, ${lightReference})`]
    };
}
